@if (assessment && (assessment.assessment || assessment.reason)) {
  <div class="simple-assessment-card" [style.background-color]="bgColor">
    <!-- テール（下向き三角） -->
    <div class="card-tail"></div>

    <!-- ヘッダー: アイコン + 評価ラベル + スコア -->
    <div class="card-header">
      @if (iconName) {
        <mat-icon [style.color]="iconColor">{{ iconName }}</mat-icon>
      }
      @if (assessment.assessment != null) {
        <span class="assessment-label">{{ assessment.assessment }}</span>
      }
      @if (assessment.score != null) {
        <span class="assessment-score">{{ assessment.score }}</span>
      }
    </div>

    <!-- ボディ: 評価理由テキスト -->
    @if (assessment.reason != null) {
      <div class="card-body">
        <div class="assessment-reason">{{ assessment.reason }}</div>
      </div>
    }
    @if (assessment.reasonDetail != null) {
      <div class="card-detail">
        <div class="assessment-reason-detail">
          {{ assessment.reasonDetail }}
        </div>
      </div>
    }
  </div>
}
